module.exports = __webpack_public_path__ + "static/wedding_2-da56be81c55902a8de71337923b9fb33.jpg";